<template lang="pug">
.absolute.inset-0
  a-scene(ref="scene" background="color: #000000" renderer="antialias: true;" vr-mode-ui="enabled: false" device-orientation-permission-ui="enabled: false")
    a-assets
      img(:id="`panoramicImage-${index + 1}`" :src='stage.panoramicImageSrc' v-for="(stage, index) in stages")
    template(v-if="current && $route.params.id")
      a-entity(ref="camera" camera="fov:120" cursor="rayOrigin: mouse;" position="0 0 0" rotation="0 0 0" :look-controls-custom="`magicWindowTrackingEnabled:${gyro?'true':'false'}`")
      a-sky(ref="sky" :src="`#panoramicImage-${$route.params.id}`" :rotation="current.panoramicImageRotation")
      box(v-if="!current.item")
  .absolute.z-30.left-0.top-0.mt-16.ml-4
    label.flex.items-center(v-if="deviceOrientationPermitted")
      input.hidden(type="checkbox" v-model="gyro")
      svg.mr-2(height="24" width="24")
        circle(cx="12" cy="12" r="11" fill="none" stroke="#fff")
        ellipse(cx="12" cy="12" rx="8" ry="3" fill="none" stroke="#fff")
        ellipse(cx="12" cy="12" rx="3" ry="8" fill="none" stroke="#fff")
        line(v-if="!gyro" x1="24" y1="0" x2="0" y2="24" fill="none" stroke="#fff")
      .text-xs.font-medium GYRO:{{ gyro? "ON" : "OFF" }}
  //
    .guide.absolute.inset-0.w-0.border-l.mx-auto
    .guide.absolute.inset-0.flex.flex-col.justify-center
      .border-t
</template>
<style lang="sass" scoped>
.guide
  pointer-events: none
</style>
<script>
import { mapState } from "vuex";
import box from "@/components/stage/box";
export default {
  components: {
    box
  },
  props: {
    current: {
      type: Object
    }
  },
  computed: {
    ...mapState("stage", ["stages"]),
    ...mapState("vr", ["deviceOrientationPermitted"]),
    gyro: {
      get() {
        return this.$store.state.vr.gyro;
      },
      set(value) {
        this.$store.commit("vr/gyro", value);
      }
    }
  },
  mounted() {
    if (
      typeof DeviceOrientationEvent !== "undefined" &&
      DeviceOrientationEvent.requestPermission
    ) {
      DeviceOrientationEvent.requestPermission().then(permission => {
        this.$store.commit(
          "vr/deviceOrientationPermitted",
          permission === "granted"
        );
      });
    }
  }
};
</script>
